import React from 'react';
import './Review.css';
import review1 from '../images/Review1.jpg';
import review2 from '../images/Review2.jpg';
import review3 from '../images/Review3.jpg';

export default function Review() {
  const reviews = [
    {
      name: 'Ar. Mayur Zala',
      quote: '“Every non-fit furniture, you can get them here. Everything.”',
      image: review1,
      link: 'https://www.instagram.com/reel/DJmSxGFyzHG/?utm_source=ig_web_button_share_sheet&igsh=MzRlODBiNWFlZA==',
    },
    {
      name: 'Ar. Mauliv Patel',
      quote: '“No need to go to any country. One stop solution for any furniture.”',
      image: review2,
      link: 'https://www.instagram.com/reel/DMLABY4vpfb/?utm_source=ig_web_button_share_sheet',
    },
    {
      name: 'Mpok Ina',
      quote: '“Sangat terjangkau untuk kantong saya yang tidak terlalu banyak”',
      image: review3,
    },
  ];

  return (
    <section className="review-section">
      <h2 className="review-title">Our Client Reviews</h2>
      <div className="review-cards">
        {reviews.map((review, index) => (
          <div className="review-card box-shadow" key={index}>
            {review.link ? (
              <a href={review.link} target="_blank" rel="noopener noreferrer">
                <img src={review.image} alt={review.name} className="review-img image-hover-zoom" />
              </a>
            ) : (
              <img src={review.image} alt={review.name} className="review-img image-hover-zoom" />
            )}
            <div className="review-overlay">
              <h4>{review.name}</h4>
              <p>{review.quote}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
